module.exports = __webpack_public_path__ + "img/logo-gigainlab.9b387b8d.png";